import axiosConfig from "./Axios";
import jwtDecode from "jwt-decode";

function setup() {
  const token = window.localStorage.getItem("authToken");
  if (token) {
    const { exp: expiration } = jwtDecode(token);
    if (expiration * 1000 > new Date().getTime()) {
      setAxiosToken(token);
    }
  }
  setAxiosToken(token);
}

function setAxiosToken(token) {
  axiosConfig.defaults.headers["Authorization"] = "Bearer " + token;
}

function reset(form) {
  return axiosConfig.post(
    process.env.REACT_APP_API_URL + "/api/reset_password/reset",
    form
  );
}

function forgot(email) {
  return axiosConfig.post(
    process.env.REACT_APP_API_URL + "/api/reset_password",
    email
  );
}

function authenticate(credentials, onLogin) {
  return axiosConfig
    .post(process.env.REACT_APP_API_URL + "/api/login_check", credentials)
    .then((response) => response.data)
    .then((data) => {
      window.localStorage.setItem("authToken", data.token);
      window.localStorage.setItem("refreshToken", data.refresh_token);
      onLogin(jwtDecode(data.token));
      setAxiosToken(data.token);
    });
}

function isAuthenticated() {
  const token = window.localStorage.getItem("authToken");

  if (token) {
    const { exp: expiration } = jwtDecode(token);
    if (expiration * 1000 > new Date().getTime()) {
      const decodedToken = jwtDecode(token);

      let switchUser = window.localStorage.getItem("switchUser");
      if (switchUser !== null) {
        switchUser = JSON.parse(switchUser);
        decodedToken.switchOriginalUser = {
          id: decodedToken.id,
          username: decodedToken.username,
          order: window.localStorage.getItem("order"),
          roles: decodedToken.roles,
          partner: decodedToken.partner,
        };
        decodedToken.id = switchUser.id;
        decodedToken.username = switchUser.email;
        decodedToken.order = switchUser.order ? switchUser.order["@id"] : null;
        decodedToken.roles = switchUser.roles;
        decodedToken.isSwitchedUser = true;
        decodedToken.partner = switchUser.partner;
      } else {
        decodedToken.isSwitchedUser = false;

        let order =
          window.localStorage.getItem("order") !== "undefined"
            ? window.localStorage.getItem("order")
            : decodedToken.order
            ? decodedToken.order
            : null;

        decodedToken.order = order;
        window.localStorage.setItem("order", order);
      }

      return decodedToken;
    }
    return false;
  }
  return false;
}

function switchUser(newUser) {
  window.localStorage.setItem("switchUser", JSON.stringify(newUser));
  window.location.href = "/";
}

function switchOriginalUser() {
  window.localStorage.removeItem("switchUser");
  window.location.href = "/";
}

function logout() {
  //window.localStorage.removeItem("order");
  window.localStorage.removeItem("authToken");
  window.localStorage.removeItem("refreshToken");
  window.localStorage.removeItem("switchUser");
  delete axiosConfig.defaults.headers["Authorization"];
}

const Auth = {
  setup,
  authenticate,
  logout,
  isAuthenticated,
  switchUser,
  switchOriginalUser,
  forgot,
  reset,
};

export default Auth;
